module.exports = __webpack_public_path__ + "static/media/sidebar.ad4f0c00.png";